"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _WKTWriter = _interopRequireDefault(require("../../io/WKTWriter"));

var _Coordinate = _interopRequireDefault(require("../../geom/Coordinate"));

var _IntervalRTreeLeafNode = _interopRequireDefault(require("./IntervalRTreeLeafNode"));

var _IntervalRTreeNode = _interopRequireDefault(require("./IntervalRTreeNode"));

var _Collections = _interopRequireDefault(require("../../../../../java/util/Collections"));

var _System = _interopRequireDefault(require("../../../../../java/lang/System"));

var _ArrayList = _interopRequireDefault(require("../../../../../java/util/ArrayList"));

var _IntervalRTreeBranchNode = _interopRequireDefault(require("./IntervalRTreeBranchNode"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var SortedPackedIntervalRTree =
/*#__PURE__*/
function () {
  function SortedPackedIntervalRTree() {
    _classCallCheck(this, SortedPackedIntervalRTree);

    SortedPackedIntervalRTree.constructor_.apply(this, arguments);
  }

  _createClass(SortedPackedIntervalRTree, [{
    key: "buildTree",
    value: function buildTree() {
      _Collections.default.sort(this._leaves, new _IntervalRTreeNode.default.NodeComparator());

      var src = this._leaves;
      var temp = null;
      var dest = new _ArrayList.default();

      while (true) {
        this.buildLevel(src, dest);
        if (dest.size() === 1) return dest.get(0);
        temp = src;
        src = dest;
        dest = temp;
      }
    }
  }, {
    key: "insert",
    value: function insert(min, max, item) {
      if (this._root !== null) throw new IllegalStateException("Index cannot be added to once it has been queried");

      this._leaves.add(new _IntervalRTreeLeafNode.default(min, max, item));
    }
  }, {
    key: "query",
    value: function query(min, max, visitor) {
      this.init();

      this._root.query(min, max, visitor);
    }
  }, {
    key: "buildRoot",
    value: function buildRoot() {
      if (this._root !== null) return null;
      this._root = this.buildTree();
    }
  }, {
    key: "printNode",
    value: function printNode(node) {
      _System.default.out.println(_WKTWriter.default.toLineString(new _Coordinate.default(node._min, this._level), new _Coordinate.default(node._max, this._level)));
    }
  }, {
    key: "init",
    value: function init() {
      if (this._root !== null) return null;
      this.buildRoot();
    }
  }, {
    key: "buildLevel",
    value: function buildLevel(src, dest) {
      this._level++;
      dest.clear();

      for (var i = 0; i < src.size(); i += 2) {
        var n1 = src.get(i);
        var n2 = i + 1 < src.size() ? src.get(i) : null;

        if (n2 === null) {
          dest.add(n1);
        } else {
          var node = new _IntervalRTreeBranchNode.default(src.get(i), src.get(i + 1));
          dest.add(node);
        }
      }
    }
  }, {
    key: "getClass",
    value: function getClass() {
      return SortedPackedIntervalRTree;
    }
  }, {
    key: "interfaces_",
    get: function get() {
      return [];
    }
  }]);

  return SortedPackedIntervalRTree;
}();

exports.default = SortedPackedIntervalRTree;

SortedPackedIntervalRTree.constructor_ = function () {
  this._leaves = new _ArrayList.default();
  this._root = null;
  this._level = 0;
};